import React from 'react';
import HelmetComponent from '../../utils/HelmetHelper';
import { requireUserAdOwnership, requireUserLogin, requireUserVerify } from '../../routes/Auth';
import requireUsernameChange from '../../routes/Auth/HOCs/requireUsernameChange';
import AdStatistics from './AdStatistics';

const AdStatisticsPage = (props) => (
  <React.Fragment>
    <HelmetComponent title={`${"Statistika"} | ${"INDEX OGLASI"}`} index={false} />

    <AdStatistics
      {...props}
    />
  </React.Fragment>
);

export default requireUserLogin(
  requireUsernameChange(
    requireUserVerify(
      requireUserAdOwnership(
        AdStatisticsPage,
        { adminBypassNotFound: true }
      )
    )
  )
);



// WEBPACK FOOTER //
// ./src/containers/AdStatisticsPage/index.tsx